import { INotificationComponent } from '../../shared/mixins/action-notification.mixin';
import { BaseStoreEditComponent } from '../../shared/components/base-store-edit-component';
import { mailWizzModule } from '../../store/mailwizz-module';
import { Component } from 'vue-property-decorator'
import { MailWizz } from '@/models/mailwizz/mailwizz';
import EditMailwizzComponent from './shared/edit-mailwizzes/mailwizzes';

@Component({
    components: {
        'edit-mailwizz': EditMailwizzComponent,
    },
})
export default class Mailwizzes extends BaseStoreEditComponent<MailWizz> implements INotificationComponent {
    mailwizzes: MailWizz[] = [];

    get storeModule() { return mailWizzModule }
    get notificationText() { return `Mailwizz: ${this.selectedItem.name}`}

    async mounted() {
        await this.refresh();
        this.selectFirst();
    }

    async refresh() {
        await mailWizzModule.getRecords();
    }

    select(mailwizz: MailWizz) {
        mailWizzModule.selectItem(mailwizz)
    }

    selectFirst() {
        const first = this.records[0];
        mailWizzModule.selectItem(first);
    }
}
